module.exports = __webpack_public_path__ + "img/slid1.9565cf97.jpg";